// src/components/reusable/Breadcrumb.jsx
import React from "react";
import theme from "../../../styles/theme"; // adapte le chemin si besoin
import { Link } from "react-router-dom";

const Breadcrumb = ({ items = [] }) => {
  return (
    <nav
      style={{
        marginBottom: theme.spacing.sm,
        fontSize: theme.fontSizes.sm,
        color: theme.colors.text.secondary,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing.xs,
        marginLeft:12,
        marginTop: theme.spacing.xs,
        
      }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span
            key={index}
            style={{ display: "flex", alignItems: "center", gap: theme.spacing.xs }}
          >
            {!isLast ? (
              <Link
                to={item.href}
                style={{
                  color: theme.colors.primary,
                  textDecoration: "none",
                  fontWeight: theme.fontWeights.sm,
                  fontSize: theme.fontSizes.sm,
                  transition: "color 0.2s",
                }}
                onMouseOver={(e) => (e.target.style.color = theme.colors.primaryHover)}
                onMouseOut={(e) => (e.target.style.color = theme.colors.primary)}
              >
                {item.label}
              </Link>
            ) : (
              <span
                style={{
                  color: theme.colors.text.primary,
                  fontWeight: theme.fontWeights.sm,
        
                }}
              >
                {item.label}
              </span>
            )}

            {/* Séparateur */}
            {!isLast && (
              <span style={{ color: theme.colors.text.muted }}>/</span>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
